export enum FilterLogicOperatorEnum {
  and = 'and',
  or = 'or',
  none = '',
}
